import React, { useState, useEffect } from 'react';
import { Form, Select, Input, Button } from 'antd';
import { get_ticket_type_listing } from '../../../../Services/employee';

const { Option } = Select;

const TicketForm = ({ types ,handleTicketForm,form}) => {
    return (
        
        <Form
        form={form}

            labelCol={{
                span: 6,
            }}
            wrapperCol={{
                span: 14,
            }}
            layout="horizontal"
            onFinish={handleTicketForm}
        >
            <Form.Item
                label="Type"
                name="TicketTypeId"
                rules={[
                    {
                        required: true,
                        message: 'Please select an option!',
                    },
                ]}
            >
                {types?.length
                    ? <Select placeholder="Select an option">
                        {types?.map(type => (
                            <Option key={type.id} value={type.id}>{type.name}</Option>
                        ))}
                    </Select>
                    : <></>}
            </Form.Item>

            <Form.Item
                label="Category"
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input text!',
                    },
                    {
                        max: 250,
                        message: 'Category must be at most 250 characters!',
                    },
                ]}
            >
                <Input maxLength={249} placeholder="Enter text" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 10, span: 14 }}>
                <Button style={{background:'#2963AD' ,color:'white'}} htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    );
};

export default TicketForm;
